// eslint-disable-next-line import/no-default-export
export default {
  PARSING: 'Pending',
  PENDING: 'Pending',
  READY: 'Starting agent',
  UPLOADING_ARTIFACTS: 'Uploading artifacts',
  UPLOADING_CACHES: 'Uploading caches',
  UPLOADING_METRICS: 'Uploading metrics',
  UPLOADING_VARIABLES: 'Uploading variables',
  DOWNLOADING_ARTIFACTS: 'Downloading artifacts',
  DOWNLOADING_CACHES: 'Downloading caches',
  DOWNLOADING_TEST_METADATA: 'Downloading test metadata',
  COMPLETING_LOGS: 'Saving logs',
  PARSING_TEST_RESULTS: 'Parsing test results',
  IN_PROGRESS: 'In progress',
  PULLING_IMAGES: 'Pulling images',
  CLONING: 'Cloning repository',
  RUNNING: 'Running',
  PAUSED: 'Paused',
  HALTED: 'Halted',
  QUEUED: 'Waiting',
  ERROR: 'Failed',
  SYSTEM_ERROR: 'System error',
  USER_ERROR: 'Error',
  FAILED: 'Failed',
  REDEPLOY: 'Redeployed',
  RERUN: 'Rerun',
  SUCCESSFUL: 'Successful',
  STOPPED: 'Stopped',
  SKIPPED: 'Skipped',
  NOT_RUN: 'Not run',
  UNDEPLOYED: 'Undeployed',
  ACTION_REQUIRED: 'Action required',
  fail: '',
  complete: '',
};
